export default {
  dbi_trendinggames_title: 'Trending Games',
  dbi_trendinggames_related_links: 'Related links',
  dbi_trendinggames_left_1: 'Game Overview',
  dbi_trendinggames_left_2: 'Store Ranks',
  dbi_trendinggames_left_3: 'Key Metrics',
  dbi_trendinggames_right_1: 'Opinions Data',
  dbi_trendinggames_right_3: 'Game Store Feeds',
  dbi_trendinggames_right_2: 'Social Media Feeds',
  dbi_trendinggames_right_4: 'Game-related News'
}